export const PRODUCT_REQUEST = 'PRODUCT_REQUEST';

export const PRODUCT_FAILURE = 'PRODUCT_FAILURE';

export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';


export const POST_PRODUCT_SUCCESS = 'POST_PRODUCT_SUCCESS';

export const SINGLE_PRODUCT_SUCCESS="SINGLE_PRODUCT_SUCCESS";

